import { ScopeCustomFieldValue } from '@app/features/scope-overview/model/scope-custom-field-value.model';

export class ScopeCustomFieldValueStructure {
  fieldValues!: Array<ScopeCustomFieldValue>

  getCustomFieldValueById = (id: string) => {
    return this.fieldValues.find(it => it.id == id);
  }
}
